   import { Navigate, useParams } from "react-router-dom";
   /** Shared reel links look like /reel/<id> (ReelCard builds them; the Android app understands them). The web player reads /reels?reelId=<id>. */
   export default function ReelDeepLinkRedirect() {
     const { reelId } = useParams();
     return <Navigate to={reelId ? `/reels?reelId=${encodeURIComponent(reelId)}` : "/reels"} replace />;
   }
   